export const getUserData = () => {
    try {
        const raw = localStorage.getItem('userdata');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const persistUserData = (patch) => {
    const current = getUserData();
    if (!current) return null;
    const updated = { ...current, ...patch };
    localStorage.setItem('userdata', JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent('smile-userdata-updated', { detail: updated }));
    if (Object.prototype.hasOwnProperty.call(patch, 'vista_pi')) {
        window.dispatchEvent(new CustomEvent('smile-vista-pi-changed', {
            detail: { vista_pi: updated.vista_pi },
        }));
    }
    return updated;
};

/** tipo_usuario: 0 = Médico, 1 = Administrativo */
export const esUsuarioAdministrativo = (userdata = getUserData()) =>
    userdata != null && String(userdata.tipo_usuario) === '1';

export const esUsuarioMedico = (userdata = getUserData()) =>
    !esUsuarioAdministrativo(userdata);

/**
 * Médicos requieren firma y registro médico; administrativos solo consultan documentos.
 */
export const usuarioPuedeIniciarAtencion = (userdata = getUserData()) => {
    if (esUsuarioAdministrativo(userdata)) {
        return true;
    }
    return Boolean(userdata?.firma) && Boolean(userdata?.registro);
};

/** vista_pi: 0 = ver todo, 1 = solo registros del profesional logueado */
export const tieneVistaPiActiva = (userdata = getUserData()) =>
    userdata != null && String(userdata.vista_pi) === '1';

/** Reemplaza checks del slug profesionalIndependiente */
export const debeFiltrarPorProfesional = (userdata = getUserData()) =>
    tieneVistaPiActiva(userdata);

/** Permiso de rol AND usuario médico (módulos clínicos HC/evolución/RIPS/gráficos) */
export const puedeAccederModuloClinico = (tienePermisoRol, userdata = getUserData()) =>
    Boolean(tienePermisoRol) && esUsuarioMedico(userdata);
